module.exports = __webpack_public_path__ + "img/ss-o-1.2e9ee5cb.png";